import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons/faArrowUpRightFromSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@mantine/core";
import Link from "next/link";

import { useTrackAnalytics } from "@/hooks/analytics.hooks";

interface VoiceAnswerLinkProps {
  href: string;
  sessionId: string;
}

export const VoiceAnswerLink = ({ href, sessionId }: VoiceAnswerLinkProps) => {
  const track = useTrackAnalytics({ session_id: sessionId });

  return (
    <Button
      className="max-w-fit px-0"
      component={Link}
      href={href}
      onClick={() => track("Voice response played")}
      rel="noopener noreferrer"
      rightSection={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}
      size="xs"
      target="_blank"
      variant="transparent"
    >
      PLAY VOICE ANSWER
    </Button>
  );
};
